<template>
    <div class="alert spacing" :class="alertClass" role="alert" v-show="show">
        <span v-html="body"></span>
    </div>
</template>

<script>
import { inject, onMounted, reactive, toRefs } from 'vue'

export default {

    props: [
        'message',
        'classes'
    ],

    setup(props) {

        const state = reactive({
            show: false,
            body: '',
            alertClass: ''
        })

        const emitter = inject('emitter')

        onMounted( () => {
            if ( props.message ) flash(props.message, props.classes)

            emitter.on('flash', (data) => flash(data.message, data.classes))
        })

        function flash(message, classes) {
            state.show = true
            state.body = message
            state.alertClass = classes

            setTimeout( () => {
                state.show = false
            }, 5000)
        }

        return {
            ...toRefs(state)
        }
    }
}
</script>

<style lang="scss" scoped>

.spacing {
    position: fixed;
    right: 25px;
    bottom: 25px;
    padding: 5px 10px;
    z-index: 100;

    &.static {
        position: static;
        margin-top: 30px;
    }

    @media ( max-width: 575px ) {

        & {
            left: 25px;
        }
    }
}

.alert {
    padding: 15px;
    margin-bottom: 20px;
    border: 1px solid transparent;
    border-radius: 4px;
    font-weight: 400;

    &.success {
        color: #3c763d;
        background-color: #dff0d8;
        border-color: #d6e9c6;
    }

    &.danger {
        color: #a94442;
        background-color: #f2dede;
        border-color: #ebccd1;
    }

    &.info {
        color: #31708f;
        background-color: #d9edf7;
        border-color: #bce8f1;
    }

    &.warning {
        color: #8a6d3b;
        background-color: #fcf8e3;
        border-color: #faebcc;
    }
}
</style>
